const FlexContainer = ({ style, children, row, ...props }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: row ? 'row' : 'column',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...(style || {}),
    }}
    {...props}
  >
    {children}
  </div>
)

const Flex = ({ style, children, ...props }) => (
  <div
    style={{
      position: 'relative',
      flex: 1,
      overflow: 'auto',
      WebkitOverflowScrolling: 'touch',
      ...(style || {}),
    }}
    {...props}
  >
    {children}
  </div>
)

export default Flex
export { Flex, FlexContainer }
